import React, { useMemo } from "react";
import DoughnutChart from "@charty/doughnut";
import { getMetricLabel } from "@linkfluence/i18n";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { SearchFragmentClassification } from "@radarly/models/search";
import { useRangeFromFragment } from "../../data";
import Empty from "../../empty";
import Tooltip from "../../tooltip/metric";
import { computeSeries } from "../compute";

export interface SharedWidgetsClassificationDoughnutChartInnerProps {
  loading: boolean;
  data: SearchFragmentClassification["data"];
  fragment: SearchFragmentClassification;
  className?: string;
  onClickLegend?: (uid: string | number) => void;
  onClickItem?: (uid: string) => void;
  disableAnimation?: boolean;
  isFullscreen?: boolean;
}

export default function SharedWidgetsOccupationsDoughnutChartInner({
  loading,
  data,
  fragment,
  className,
  onClickLegend,
  onClickItem,
  disableAnimation,
  isFullscreen,
}: SharedWidgetsClassificationDoughnutChartInnerProps) {
  const locale = useCurrentUserLocale();
  const metric = fragment.request.aggs.contentClassification.metrics[0];
  const dataset = useMemo(() => {
    return computeSeries(
      data ? data.aggs.contentClassification.values : [],
      metric,
      "head",
      locale
    );
  }, [data, locale, metric]);
  const range = useRangeFromFragment(fragment, loading);
  return (
    <Empty empty={!dataset.length}>
      <DoughnutChart
        locale={locale}
        series={dataset}
        className={className}
        orderBy="numeric"
        onClickPie={onClickItem}
        onClickLegend={onClickLegend}
        centerLabel={getMetricLabel(locale, metric)}
        tooltip={(serie) => (
          <Tooltip
            range={range}
            count={serie.count}
            color={serie.color}
            label={serie.label}
            metric={metric}
            locale={locale}
          />
        )}
        disableAnimation={disableAnimation}
        isFullscreen={isFullscreen}
      />
    </Empty>
  );
}
